import { ArrowRight, TrendingUp, Shield, Users, Zap, Rocket, Building2, Coins, BookOpen, Lightbulb, Heart, Target, Globe } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';

const AboutPage = () => {
  const { language } = useLanguage();

  // Founder's Journey Timeline - Reversed order (most recent first)
  const timeline = [
    { 
      year: 'TBA', 
      title: language === 'es' ? 'Plataforma de Inversión Tokenizada' : 'Tokenized Investment Platform',
      description: language === 'es' 
        ? 'Infraestructura blockchain propia. Tokenización de activos inmobiliarios. Acceso global democratizado.'
        : 'Proprietary blockchain infrastructure. Real estate asset tokenization. Democratized global access.',
      icon: Globe,
      upcoming: true
    },
    { 
      year: '2026-27', 
      title: language === 'es' ? 'Lanzamiento "AAC Real Estate I"' : '"AAC Real Estate I" Launch',
      description: language === 'es' 
        ? 'Fondo inmobiliario ético. +20% objetivo anualizado. Renovación de propiedades infravaloradas en España.'
        : 'Ethical real estate fund. +20% annualized target. Undervalued property renovation in Spain.',
      icon: Rocket,
      upcoming: true
    },
    { 
      year: '2025', 
      title: language === 'es' ? 'Expansión a Real Estate' : 'Real Estate Expansion',
      description: language === 'es' 
        ? 'Primeras operaciones inmobiliarias. IA + Big Data + red exclusiva = sourcing del top 1%.'
        : 'First real estate operations. AI + Big Data + exclusive network = top 1% sourcing.',
      icon: Building2
    },
    { 
      year: '2024', 
      title: language === 'es' ? '$100k AUM → 42% ROI' : '$100k AUM → 42% ROI',
      description: language === 'es' 
        ? 'Q1: $42k en comisiones. Cuenta fondeada de $100k en Prop Firm. Metodología validada.'
        : 'Q1: $42k in commissions. $100k funded account at Prop Firm. Methodology validated.',
      icon: Target
    },
    { 
      year: '2023', 
      title: language === 'es' ? 'Primeros Retornos Significativos' : 'First Significant Returns',
      description: language === 'es' 
        ? 'Q4: $14k comisiones. $50k cuenta fondeada. 28% ROI. Proof of concept.'
        : 'Q4: $14k commissions. $50k funded account. 28% ROI. Proof of concept.',
      icon: Coins
    },
    { 
      year: 'H2\'21', 
      title: language === 'es' ? 'Liderazgo Blockchain' : 'Blockchain Leadership',
      description: language === 'es' 
        ? 'De $0 en bear market. Red y habilidades = salvavidas. Proyecto de $0 → $100M valoración. Líder en Polkadot. "Little Jimmo" forjó relaciones de por vida. Agradecido.'
        : 'From $0 in bear market. Network and skills = lifeline. Project from $0 → $100M valuation. Polkadot leader. "Little Jimmo" forged lifelong relationships. Grateful.',
      icon: Users
    },
    { 
      year: 'H1\'21', 
      title: language === 'es' ? '⚡ Segunda Lección: Presión' : '⚡ Second Lesson: Pressure',
      description: language === 'es' 
        ? '$2K → $40K tras 4 años de sacrificio. ¡Tenía razón! Pero no había dominado las emociones ni el enfoque ante problemas externos. Lo perdí todo. Lección aprendida.'
        : '$2K → $40K after 4 years of sacrifice. Was right! But hadn\'t mastered emotions or focus despite external problems. Lost it all. Lesson learned.',
      icon: Zap
    },
    { 
      year: '2019', 
      title: language === 'es' ? 'Años de Trinchera' : 'Trench Years',
      description: language === 'es' 
        ? 'Años duros en casa. Inmersión total: blockchain + divisas. Macro, estrategias, charts. HODL con convicción (Chromia). Networking orgánico.'
        : 'Hard years at home. Full immersion: blockchain + currencies. Macro, strategies, charts. HODL with conviction (Chromia). Organic networking.',
      icon: BookOpen
    },
    { 
      year: '2018', 
      title: language === 'es' ? 'Trading Cuantitativo' : 'Quantitative Trading',
      description: language === 'es' 
        ? 'Entrada a Forex y Oro. Patrones de comportamiento humano en gráficos. Análisis técnico avanzado. Preventas crypto a largo plazo.'
        : 'Entry to Forex and Gold. Human behavior patterns in charts. Advanced technical analysis. Long-term crypto presales.',
      icon: TrendingUp
    },
    { 
      year: '2017', 
      title: language === 'es' ? '📚 Primera Lección: Fundamentos' : '📚 First Lesson: Fundamentals',
      description: language === 'es' 
        ? '18 años. $800 ahorrados de pequeños negocios. Familia desahuciada. ICO mania: $800 → $20k. Errores: no asegurar ganancias, scams. Vuelta a $2k. Humildad.'
        : '18 years old. $800 saved from small businesses. Evicted family. ICO mania: $800 → $20k. Mistakes: not securing profits, scams. Back to $2k. Humility.',
      icon: Lightbulb
    },
    { 
      year: '2014', 
      title: language === 'es' ? 'Descubrimiento de Bitcoin' : 'Bitcoin Discovery',
      description: language === 'es' 
        ? 'Encontré BTC pero no pude entrar. Autodidacta: blockchain, criptografía, descentralización. La semilla fue plantada.'
        : 'Found BTC but couldn\'t enter. Self-taught: blockchain, cryptography, decentralization. The seed was planted.',
      icon: Lightbulb
    },
    { 
      year: language === 'es' ? '💒 Infancia' : '👒 Childhood', 
      title: language === 'es' ? 'Raíces y Valores' : 'Roots & Values',
      description: language === 'es' 
        ? 'Ayudando a la familia desde pequeño. Pequeños negocios. Obras en ciudad y campo. Justicia, matemáticas, física, el universo. Sueño: un fondo que haga el mundo mejor.'
        : 'Helping family since young. Small businesses. Construction in city and countryside. Justice, mathematics, physics, the universe. Dream: a fund to make the world better.',
      icon: Heart
    },
  ];

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <Navbar />
      
      {/* Hero with Background Image */}
      <section className="relative pt-24 pb-16 px-4">
        <div 
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: 'url(https://customer-assets.emergentagent.com/job_972a2ae2-9c5a-40a4-b89e-5ecb188d7363/artifacts/kqjakkk1_image.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'top center'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-950/70 via-gray-950/90 to-gray-950"></div>
        
        <div className="max-w-4xl mx-auto text-center relative z-10 pt-8">
          <p className="text-cyan-400 text-sm tracking-[0.3em] mb-4">
            {language === 'es' ? 'EQUIPO DIRECTIVO' : 'MANAGEMENT TEAM'}
          </p>
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            {language === 'es' ? 'Trayectoria del Fundador' : 'Founder\'s Track Record'}
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            {language === 'es' 
              ? 'Experiencia verificable. Resultados medibles.' 
              : 'Verifiable experience. Measurable results.'}
          </p>
        </div>
      </section>

      {/* The Name & Logo */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8 md:p-12">
            <div className="grid md:grid-cols-2 gap-10 items-center">
              <div>
                <p className="text-cyan-400 text-sm tracking-wider mb-3">
                  {language === 'es' ? 'EL NOMBRE' : 'THE NAME'}
                </p>
                <h2 className="text-2xl md:text-3xl font-bold mb-4">
                  {language === 'es' ? '¿Por qué "Accretion Axiom"?' : 'Why "Accretion Axiom"?'}
                </h2>
                <p className="text-gray-400 mb-4">
                  {language === 'es' 
                    ? 'En astrofísica, un disco de acreción es materia que se acumula gradualmente en torno a un objeto masivo, incrementando su tamaño de forma continua. Representa una de las fuerzas más poderosas del universo.'
                    : 'In astrophysics, an accretion disk is matter gradually accumulating around a massive object, continuously increasing its size. It represents one of the most powerful forces in the universe.'}
                </p>
                <p className="text-gray-400 mb-4">
                  {language === 'es'
                    ? 'Un axioma es una verdad fundamental que no requiere demostración.'
                    : 'An axiom is a fundamental truth that requires no proof.'}
                </p>
                <p className="text-gray-300">
                  {language === 'es'
                    ? 'La combinación: crecimiento constante fundamentado en principios sólidos.'
                    : 'The combination: constant growth founded on solid principles.'}
                </p>
              </div>
              <div className="flex justify-center">
                <div className="relative">
                  <div className="absolute inset-0 bg-cyan-500/20 rounded-full blur-3xl"></div>
                  <img 
                    src="https://customer-assets.emergentagent.com/job_realestate-fund-6/artifacts/qsxu12yq_1_LE_upscale_balanced_x4.webp"
                    alt="Accretion Disk"
                    className="w-48 h-48 md:w-64 md:h-64 object-contain relative z-10"
                    style={{ filter: 'hue-rotate(180deg) saturate(1.3)' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-cyan-400 text-sm tracking-wider mb-3">
              {language === 'es' ? 'FILOSOFÍA DE INVERSIÓN' : 'INVESTMENT PHILOSOPHY'}
            </p>
            <h2 className="text-2xl md:text-3xl font-bold">
              {language === 'es' ? 'Principios Fundamentales' : 'Core Principles'}
            </h2>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
              <Shield size={24} className="text-cyan-400 mb-4" />
              <h3 className="text-lg font-bold mb-2">
                {language === 'es' ? 'Ética e Integridad' : 'Ethics & Integrity'}
              </h3>
              <p className="text-gray-400 text-sm">
                {language === 'es'
                  ? 'Cada inversión debe generar valor tangible. En inmobiliario, creamos vivienda. En trading, aplicamos gestión de riesgo rigurosa.'
                  : 'Every investment must generate tangible value. In real estate, we create housing. In trading, we apply rigorous risk management.'}
              </p>
            </div>
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
              <TrendingUp size={24} className="text-cyan-400 mb-4" />
              <h3 className="text-lg font-bold mb-2">
                {language === 'es' ? 'Transparencia Total' : 'Full Transparency'}
              </h3>
              <p className="text-gray-400 text-sm">
                {language === 'es'
                  ? 'Sin comisiones ocultas. Rendimiento público y verificable. Dashboard de resultados en tiempo real disponible para todos los inversores.'
                  : 'No hidden fees. Public and verifiable performance. Real-time results dashboard available to all investors.'}
              </p>
            </div>
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
              <Zap size={24} className="text-cyan-400 mb-4" />
              <h3 className="text-lg font-bold mb-2">
                {language === 'es' ? 'Metodología Cuantitativa' : 'Quantitative Methodology'}
              </h3>
              <p className="text-gray-400 text-sm">
                {language === 'es'
                  ? 'Análisis basado en datos, IA y timing de mercado. El acceso al top 1% de oportunidades es resultado de metodología, no de suerte.'
                  : 'Data-driven analysis, AI, and market timing. Access to top 1% opportunities is the result of methodology, not luck.'}
              </p>
            </div>
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
              <Users size={24} className="text-cyan-400 mb-4" />
              <h3 className="text-lg font-bold mb-2">
                {language === 'es' ? 'Acceso Institucional' : 'Institutional Access'}
              </h3>
              <p className="text-gray-400 text-sm">
                {language === 'es'
                  ? 'Estrategias de grado institucional disponibles para inversores minoristas. Sin requisitos de capital mínimo prohibitivo.'
                  : 'Institutional-grade strategies available to retail investors. No prohibitive minimum capital requirements.'}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline - Founder's Journey (Reversed) */}
      <section className="py-16 px-4 bg-gray-900/30">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-cyan-400 text-sm tracking-wider mb-3">
              {language === 'es' ? 'TRAYECTORIA PROFESIONAL' : 'PROFESSIONAL TRAJECTORY'}
            </p>
            <h2 className="text-2xl md:text-3xl font-bold">
              {language === 'es' ? 'Cronología' : 'Timeline'}
            </h2>
          </div>
          
          <div className="relative">
            {/* Vertical line */}
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gray-800 md:-translate-x-px"></div>
            
            <div className="space-y-8">
              {timeline.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div key={item.year} className={`relative flex items-start gap-6 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>
                    {/* Dot */}
                    <div className={`absolute left-4 md:left-1/2 w-3 h-3 rounded-full -translate-x-1/2 mt-1.5 z-10 ${item.upcoming ? 'bg-yellow-500 animate-pulse' : 'bg-cyan-500'}`}></div>
                    
                    {/* Content */}
                    <div className={`ml-12 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12'}`}>
                      <div className={`flex items-center gap-2 ${index % 2 === 0 ? 'md:justify-end' : ''}`}>
                        <IconComponent size={16} className={item.upcoming ? 'text-yellow-400' : 'text-cyan-400'} />
                        <span className={`font-bold ${item.upcoming ? 'text-yellow-400' : 'text-cyan-400'}`}>{item.year}</span>
                        {item.upcoming && <span className="text-xs bg-yellow-500/20 text-yellow-400 px-2 py-0.5 rounded">{language === 'es' ? 'PRÓXIMO' : 'UPCOMING'}</span>}
                      </div>
                      <h3 className="text-lg font-semibold mt-1">{item.title}</h3>
                      <p className="text-gray-400 text-sm mt-1">{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* CTA to Results */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-gray-900 via-cyan-950/30 to-gray-900 border border-cyan-700/40 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl"></div>
            
            <div className="relative z-10">
              <p className="text-cyan-400 text-sm tracking-wider mb-3">
                {language === 'es' ? 'RESULTADOS VERIFICABLES' : 'VERIFIABLE RESULTS'}
              </p>
              <h2 className="text-2xl md:text-3xl font-bold mb-4">
                {language === 'es' ? 'Consulta el Rendimiento en Vivo' : 'Check Live Performance'}
              </h2>
              <p className="text-gray-400 mb-8 max-w-lg mx-auto">
                {language === 'es'
                  ? 'Dashboard público con operaciones reales y retornos verificados. Transparencia total.'
                  : 'Public dashboard with real trades and verified returns. Full transparency.'}
              </p>
              <a 
                href="/quantitative/results" 
                className="inline-flex items-center bg-cyan-500 hover:bg-cyan-400 text-black font-semibold px-8 py-3 rounded-lg transition-colors"
              >
                {language === 'es' ? 'Ver Resultados' : 'View Results'}
                <ArrowRight className="ml-2" size={18} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
